module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Snowfall-S2.2ee3493.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Snowfall-S2.jpg
// module id = Tc0v
// module chunks = 0